import React from 'react';

import AreaHeader from '@app/components/UI/Area-blocks/AreaHeader/AreaHeader';
import MiddleText from '@app/components/UI/MiddleText/MiddleText';
import SliderAreaVetCarousel from '@app/components/UI/Slider/SliderAreaVetCarousel';
import { Area } from '@app/objects/Area';

const AreaVets: React.FC<{ area: Area }> = ({ area }) => {
	return (
		<div className="area">
			<AreaHeader area={area} />

			<MiddleText title="Meet the veterinarians">
				{area?.veterinarians?.length ? (
					<SliderAreaVetCarousel sliderItems={area.veterinarians} />
				) : (
					<div className="middle-text__text">
						<p>
							Lap of Love's compassionate veterinarians in
							{` ${area?.city || 'the city'} `}
							are here to support you and your pet with end-of-life care in the
							comfort of home.
						</p>
						<p>
							Our Support Center is available daily from 7am - 11pm to answer questions and help you schedule a visit from your local
							{` ${area?.city || ''} `}
							veterinarian.
						</p>
					</div>
				)}
			</MiddleText>
		</div>
	);
};

export default AreaVets;
